// NODE MODULE IMPORTS
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
// ASSETS
import userimg from "./assets/images/user.png";
import sloganImage from "./assets/images/slogan.png";
import { ReactComponent as LangIcon } from "./assets/svg/lang.svg";
import { ReactComponent as ArrowDownIcon } from "./assets/svg/arrow-down.svg";
import { ReactComponent as BurgerIcon } from "./assets/svg/burger.svg";
import { ReactComponent as SunIcon } from "./assets/svg/sun-icon.svg";
import { ReactComponent as MoonIcon } from "./assets/svg/moon-icon.svg";
import { ReactComponent as LogoutIcon } from "./assets/svg/logout.svg";
import { ReactComponent as UserIcon } from "./assets/svg/user.svg";
// STYLE
import styles from "./styles/style.module.scss";
// STORE
import { getCurrentUser } from "store/actions";
// FILES
import { Context } from "../../../wrapper";
import Arabic from "lang/ar.json";
import English from "lang/en.json";

const Header = ({
    sidebarCollapsed,
    // setSidebarCollapsed,
    setOffcanvasShow,
}) => {
    const { locale } = useIntl();
    const dispatch = useDispatch();
    const {
        authentication: { user },
    } = useSelector((state) => state);

    // USER DISPATCHER
    useEffect(() => {
        dispatch(getCurrentUser());
    }, [dispatch]);

    // SIDEBAR TOGGLE FUNCTION
    // const sidebarToggle = () => {
    //     setSidebarCollapsed((prev) => !prev);
    // };

    const context = useContext(Context);

    // THEME SWITCHER CONTROL
    const [theme, setTheme] = useState(
        localStorage.getItem("theme") || "light"
    );
    useEffect(() => {
        document.documentElement.setAttribute("data-theme", theme);
        document.body.classList.toggle("dark", theme === "dark");
    }, [theme]);
    const toggleTheme = () => {
        setTheme((prevTheme) => {
            const newTheme = prevTheme === "dark" ? "light" : "dark";
            localStorage.setItem("theme", newTheme);
            return newTheme;
        });
    };

    // LANGUAGE DROPDOWN CONTROL
    const [langSwitchOpen, setLangSwitchOpen] = useState(false);
    const langDropdownRef = useRef(null);
    const toggleLangDropdown = () => setLangSwitchOpen(!langSwitchOpen);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                langDropdownRef.current &&
                !langDropdownRef.current.contains(event.target)
            ) {
                setLangSwitchOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const handleChangeLangOnClick = (locale) => {
        localStorage.setItem("lang", locale);

        context.setLocale({
            lang: locale,
            messages: locale === "ar" ? Arabic : English,
        });

        document.body.setAttribute("dir", locale === "ar" ? "rtl" : "ltr");
        document.documentElement.lang = locale === "ar" ? "ar" : "en";
        document.querySelector("title").textContent =
            locale === "ar" ? "لوحة التحكم" : "Dashboard";
    };

    // USER DROPDOWN CONTROL
    const [userControlOpen, setUserControlOpen] = useState(false);
    const userDropdownRef = useRef(null);
    const toggleUserDropdown = () => setUserControlOpen(!userControlOpen);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                userDropdownRef.current &&
                !userDropdownRef.current.contains(event.target)
            ) {
                setUserControlOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <>
            <div className={`${styles["main-head"]}`}>
                <div
                    className={`wrapper ${sidebarCollapsed ? "collapsed" : ""}`}
                >
                    <div className="head-wrp">
                        <div className="d-flex">
                            {/* DESKTOP MENU BUTTON */}
                            {/* <div className="burgerBtn desktop">
                                <button
                                    className="toggleSidebar"
                                    onClick={sidebarToggle}
                                >
                                    <BurgerIcon />
                                </button>
                            </div> */}
                            {/* MOBILE MENU BUTTON */}
                            <div className="burgerBtn mobile">
                                <button
                                    className="toggleSidebar"
                                    onClick={() => setOffcanvasShow(true)}
                                >
                                    <BurgerIcon />
                                </button>
                            </div>
                        </div>
                        {/* LOGO */}
                        <div className="image-container">
                            <Link to="/">
                                <img src={sloganImage} alt="" />
                            </Link>
                        </div>
                        {/* HEADER ACTIONS */}
                        <div className="header-actions">
                            {/* THEME SWITCH */}
                            <div className="theme-switch">
                                <div
                                    className="theme-icon"
                                    onClick={toggleTheme}
                                >
                                    {theme === "light" ? (
                                        <MoonIcon />
                                    ) : (
                                        <SunIcon />
                                    )}
                                </div>
                            </div>
                            {/* LANGUAGE CONTROL */}
                            <div className="language-switch">
                                <div
                                    className="dropdown-container"
                                    ref={langDropdownRef}
                                >
                                    <div
                                        className="dropdown-toggler"
                                        onClick={toggleLangDropdown}
                                    >
                                        <LangIcon className="language-icon" />
                                        <span className="language-name">
                                            {locale === "ar"
                                                ? "العربية"
                                                : "English"}
                                        </span>
                                    </div>

                                    <div
                                        className={`dropdown-menu ${
                                            langSwitchOpen
                                                ? "fade-in"
                                                : "fade-out"
                                        }`}
                                    >
                                        <div className="dropdown-content">
                                            <Link
                                                to={`#!`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleChangeLangOnClick(
                                                        "ar"
                                                    );
                                                }}
                                            >
                                                <Dropdown.Item as={"span"}>
                                                    العربية
                                                </Dropdown.Item>
                                            </Link>
                                            <Link
                                                to={`#!`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleChangeLangOnClick(
                                                        "en"
                                                    );
                                                }}
                                            >
                                                <Dropdown.Item as={"span"}>
                                                    English
                                                </Dropdown.Item>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* USER CONTROL */}
                            <div className="user-control">
                                <div
                                    className="dropdown-container"
                                    ref={userDropdownRef}
                                >
                                    <div
                                        className="dropdown-toggler"
                                        onClick={toggleUserDropdown}
                                    >
                                        <div className="user-image">
                                            <img
                                                src={user?.image || userimg}
                                                alt=""
                                            />
                                        </div>
                                        <div className="user-info">
                                            <span className="name">
                                                {user?.firstName ||
                                                    user?.userName || (
                                                        <FormattedMessage
                                                            id={"manager"}
                                                        />
                                                    )}
                                            </span>
                                            <span className="role">
                                                {user?.role?.name || (
                                                    <FormattedMessage id="manager" />
                                                )}
                                            </span>
                                        </div>
                                        <div className="dropdown-icon">
                                            <ArrowDownIcon />
                                        </div>
                                    </div>

                                    <div
                                        className={`dropdown-menu ${
                                            userControlOpen
                                                ? "fade-in"
                                                : "fade-out"
                                        }`}
                                    >
                                        <div className="dropdown-content">
                                            <Link
                                                to={`/profile`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleChangeLangOnClick(
                                                        "ar"
                                                    );
                                                }}
                                            >
                                                <Dropdown.Item
                                                    className="profile"
                                                    as={"span"}
                                                >
                                                    <UserIcon />
                                                    <FormattedMessage id="profile" />
                                                </Dropdown.Item>
                                            </Link>
                                            <Link
                                                to={`/logout`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleChangeLangOnClick(
                                                        "ar"
                                                    );
                                                }}
                                            >
                                                <Dropdown.Item
                                                    as={"span"}
                                                    className="logout"
                                                >
                                                    <LogoutIcon />
                                                    <FormattedMessage
                                                        id={"logout"}
                                                    />
                                                </Dropdown.Item>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Header;
